const storeorder = [{
  path: '/store_sale',
  component: () => import('@/views/orders/storeorder/View'),
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    component: () => import('@/views/orders/storeorder/List')
  }, {
    path: 'create',
    component: () => import('@/views/orders/storeorder/Create')
  }, {
    path: ':store_id',
    component: () => import('@/views/orders/storeorder/Pick')
  }, {
    path: ':store_id/pick',
    name: 'instore_pick_order',
    component: () => import('@/views/orders/storeorder/PickProcess')
  }]
}]
export default storeorder
